export const CUSTOMER_INFORMATIONS_UPDATED = 'CUSTOMER_INFORMATIONS_UPDATED';
export const CUSTOMER_INFORMATIONS_SAVED = 'CUSTOMER_INFORMATIONS_SAVED';
export const CUSTOMER_INFORMATIONS_READY = 'CUSTOMER_INFORMATIONS_READY';

export function customerInformationsUpdated(informations) {
  return {
    type: CUSTOMER_INFORMATIONS_UPDATED,
    informations,
  };
}

export function customerInformationsSaved(values) {
  return {
    type: CUSTOMER_INFORMATIONS_SAVED,
    values,
  };
}

export function customerInformationsDataReady(informations) {
  return {
    type: CUSTOMER_INFORMATIONS_READY,
    informations,
  };
}



// WEBPACK FOOTER //
// ./src/services/DataServices/CustomerInformationService/actions.js